import { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const WishlistContext = createContext();

const loadWishlist = () => {
  try {
    const saved = localStorage.getItem('skinnthrive_wishlist');
    return saved ? JSON.parse(saved) : [];
  } catch { return []; }
};

export const WishlistProvider = ({ children }) => {
  const [items, setItems] = useState(loadWishlist);

  useEffect(() => {
    localStorage.setItem('skinnthrive_wishlist', JSON.stringify(items));
  }, [items]);

  const isWishlisted = (id) => items.some(i => i.id === id);

  const toggleWishlist = (product) => {
    if (isWishlisted(product.id)) {
      setItems(prev => prev.filter(i => i.id !== product.id));
      toast('Removed from wishlist', { icon: '💔' });
    } else {
      setItems(prev => [...prev, product]);
      toast.success('Added to wishlist!', { icon: '❤️' });
    }
  };

  const removeFromWishlist = (id) => setItems(prev => prev.filter(i => i.id !== id));

  return (
    <WishlistContext.Provider value={{ items, itemCount: items.length, isWishlisted, toggleWishlist, removeFromWishlist }}>
      {children}
    </WishlistContext.Provider>
  );
};

export const useWishlist = () => {
  const ctx = useContext(WishlistContext);
  if (!ctx) throw new Error('useWishlist must be inside WishlistProvider');
  return ctx;
};
